/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Ip_Item_3Inputs */

const es_tyc_ip_item_3 = /** @type {(inputs: Tyc_Ip_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No debe eliminar, ocultar ni modificar avisos de propiedad intelectual incluidos en el Servicio.`)
};

const en_tyc_ip_item_3 = /** @type {(inputs: Tyc_Ip_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must not remove, obscure, or modify any intellectual property notices included in the Service.`)
};

/**
* | output |
* | --- |
* | "You must not remove, obscure, or modify any intellectual property notices included in the Service." |
*
* @param {Tyc_Ip_Item_3Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_ip_item_3 = /** @type {((inputs?: Tyc_Ip_Item_3Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Ip_Item_3Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_ip_item_3(inputs)
	return en_tyc_ip_item_3(inputs)
});
export { tyc_ip_item_3 as "tyc.ip.item_3" }